module.exports = __webpack_public_path__ + "static/media/banano1.70c185c2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/banano/banano1.jpeg
// module id = 38
// module chunks = 0